import { AuthServiceConfig } from '@vis-auth/vis-auth';
import {
  getSsaClientId,
  getSsaScope,
  sessionTimers,
  requestPathPrefix,
  getAuthLifecylceHooks,
  getSsaRole,
} from './auth-config-helpers';

export const getSsaAuthConfiguration = (): AuthServiceConfig => {
  // SSA Role is how the application determines if the user is trying to use the ISAM Simulator or ISAM IDP
  // It is currently only utilized in external test
  const ssaRole = getSsaRole();
  return {
    issuer: '/api/identity/v1',
    clientId: getSsaClientId(ssaRole),
    redirectUri: `${window.location.origin}/save/app/client/ui/home`,
    tokenStorage: 'local',
    errorPath: '/save/app/client/ui/error',
    scope: getSsaScope(ssaRole),
    session: sessionTimers,
    role: ssaRole,
    refreshUri: `${window.location.origin}${requestPathPrefix}/refresh_session`,
    hooks: getAuthLifecylceHooks(),
  };
};
